export const DEPOSITS_CLOSED = true;
export const DEPOSITS_CLOSED_MESSAGE =
  'Pool, farm and staking deposits are closed. Withdrawals and reward claims remain available.';

export const isClosedDepositPath = (path: string): boolean =>
  DEPOSITS_CLOSED &&
  (/^\/(pools|farms|staking|earn-bitcoin)\/.*\/(?:deposit|migrate)(?:\/|$)/.test(
    path,
  ) ||
    /^\/pools\/create(?:\/|$)/.test(path));
